import React from 'react';

import type { Entity, Widget } from '../entities';
import { TrackingCategory } from '../enums';

export interface TrackingContextValue {
  category: TrackingCategory;
  widget?: Widget;
  entities?: Entity[];
  isMobileEmbedded?: boolean;
}

export const TrackingContext = React.createContext<TrackingContextValue>({
  category: TrackingCategory.Stars
});
